import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetGoldPrices(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldPricesAttempt', handleGetGoldPrices, api);
}

function* handleGetGoldPrices(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getGoldPrices], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetGoldPricesFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetGoldPricesSuccess(response.data));
    }
}
